<template lang="pug">
  .header__socials
    a.header__socials-link.animated(
      @click="sendMetricks"
      ref="links"
      v-for="item in socials"
      :key="item.code"
      :class="`header__socials-link_${item.code}`"
      :href="item.href"
      target="_blank"
      :style="{opacity: 1}"
      rel="noopener noreferrer"
    )
</template>

<script>
import metricks from '@/mixins/metricks'
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderSocials',
  mixins: [metricks],
  computed: {
    ...mapGetters('main',
      {
        socials: 'getSocialLinks'
      }
    )
  }
}
</script>
